import { AuthenticationService } from './../../../../services/authentication.service';
import { Component } from '@angular/core';
import { HeaderService } from '../../../../services/header.service';
import { RoutingUrl } from './../../../shared/enum/routing-url.enum';
import { SharedService } from '../../../../services/shared.service';
import { Router, NavigationEnd } from '@angular/router';
import { filter } from 'rxjs/operators';
import { environment } from '../../../../environments/environment';

@Component({
    selector: 'app-subheader',
    templateUrl: './subheader.component.html',
    styleUrls: ['./subheader.component.scss']
})
export class SubheaderComponent {
    routingUrl = RoutingUrl;
    isDashboard: boolean = false;
    applicationName: string;

    constructor(
        public headerService: HeaderService,
        private _sharedService: SharedService,
        private _authService: AuthenticationService,
        private router: Router
    ) {
        this.applicationName = environment.Application;

        router.events.pipe(
            filter(event => event instanceof NavigationEnd)
        ).subscribe((event: NavigationEnd) => {
            this.isDashboard = event.url.indexOf("property/property-listing") != -1;
        });
        this.headerService.header = null;
    }

    // toggleSideNav() {
    //     if (window.innerWidth < 768) {
    //         this._sharedService.sideNav.toggle();
    //     }
    // }

    toggleSideNav() {
        this._sharedService.sideNav.toggle();
    }

    logout() {
        this._authService.logout();
    }

    counter(numberOfLayer: number) {
        return new Array(numberOfLayer ?? 0);
    }
}
